(() => {
  if (window.__hengeClearArticleLpTrackingDocument === document) return;
  window.__hengeClearArticleLpTrackingDocument = document;

  const sendEvent = (eventName, params = {}) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...params });
    }
  };

  const init = () => {
    const form = document.querySelector('[data-clear-article-form-watch], #clear-article-lp-form');
    const sticky = document.querySelector('.henge-clear-article-sticky-cta');
    const normalCtas = Array.from(document.querySelectorAll('[data-event="clear_article_lp_cta_click"]')).filter((cta) => cta !== sticky);

    sendEvent('clear_article_lp_view', { page_type: 'clear_article_lp' });

    document.addEventListener('click', (event) => {
      const cta = event.target.closest('[data-event="clear_article_lp_cta_click"]');
      if (!cta) return;

      sendEvent('clear_article_lp_cta_click', {
        cta_position: cta.dataset.ctaPosition || 'unknown',
        link_url: cta.getAttribute('href') || ''
      });

      const href = cta.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        const target = document.querySelector(href);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });

    if (!form || !('IntersectionObserver' in window)) return;

    let formEventSent = false;
    const formObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (sticky) sticky.classList.add('is-hidden-near-form');
          if (!formEventSent) {
            formEventSent = true;
            sendEvent('clear_article_lp_form_view', { page_type: 'clear_article_lp' });
          }
        } else if (sticky) {
          sticky.classList.remove('is-hidden-near-form');
        }
      });
    }, { threshold: 0.2 });

    formObserver.observe(form);

    if (!sticky) return;

    const updateStickyState = () => {
      const isNormalCtaVisible = normalCtas.some((cta) => {
        const style = window.getComputedStyle(cta);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        const rect = cta.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      });
      const formRect = form.getBoundingClientRect();
      const isFormNear = formRect.bottom > 0 && formRect.top < window.innerHeight * 0.92;
      const footer = document.querySelector('footer, .site-footer, #shopify-section-footer');
      const footerRect = footer ? footer.getBoundingClientRect() : null;
      const isFooterNear = footerRect ? footerRect.top < window.innerHeight : false;
      sticky.classList.toggle('is-hidden-near-cta', isNormalCtaVisible);
      sticky.classList.toggle('is-hidden-near-form', isFormNear);
      sticky.classList.toggle('is-hidden-near-footer', isFooterNear);
    };

    let ticking = false;
    const requestStickyUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        updateStickyState();
      });
    };

    const ctaObserver = new IntersectionObserver((entries) => {
      entries.forEach(requestStickyUpdate);
    }, { rootMargin: '-8% 0px -18% 0px', threshold: 0.28 });
    normalCtas.forEach((cta) => ctaObserver.observe(cta));

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    requestStickyUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
